module.exports = __webpack_public_path__ + "img/INVENTORY.344217a6.svg";